export default __webpack_public_path__ + "static/media/SB1.1202a41d.jpg";